var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLowOutGoingSwitchClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "155px",
    height: "99px",
    viewBox: "0 0 155 99",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u4F4E\u538B\u51FA\u7EBF\u56DE\u8DEF-\u5F00\u5173-\u95ED\u5408") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3076-\\u4E00\\u6B21\\u8FDB\\u7EBF\\u56FE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1220.000000, -1175.000000)",
    id: "\\u4F4E\\u538B\\u51FA\\u7EBF\\u56DE\\u8DEF-\\u5F00\\u5173-\\u95ED\\u5408"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1221.000000, 1176.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-44",
    stroke: "#E64242",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 1.2672155e-14,
    x2: 0.5,
    y2: 96,
    id: "\\u76F4\\u7EBF",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(107.000000, 10.500000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 8.5,
    cy: 14.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 1.5,
    x2: 7,
    y2: 9.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-3",
    strokeLinecap: "square",
    transform: "translate(8.500000, 5.500000) rotate(-90.000000) translate(-8.500000, -5.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: -1.5,
    x2: 7,
    y2: 6.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-4",
    strokeLinecap: "square",
    transform: "translate(8.500000, 2.500000) rotate(-90.000000) translate(-8.500000, -2.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 4.5,
    x2: 12.5,
    y2: 4.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-2",
    strokeLinecap: "square",
    transform: "translate(8.500000, 4.500000) rotate(-90.000000) translate(-8.500000, -4.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.08663079e-14,
    y1: 14.5,
    x2: 17,
    y2: 14.5,
    id: "\\u76F4\\u7EBF-4",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 8.5,
    cy: 37.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 24.5,
    x2: 7,
    y2: 32.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-3",
    strokeLinecap: "square",
    transform: "translate(8.500000, 28.500000) rotate(-90.000000) translate(-8.500000, -28.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 21.5,
    x2: 7,
    y2: 29.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-4",
    strokeLinecap: "square",
    transform: "translate(8.500000, 25.500000) rotate(-90.000000) translate(-8.500000, -25.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 27.5,
    x2: 12.5,
    y2: 27.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-2",
    strokeLinecap: "square",
    transform: "translate(8.500000, 27.500000) rotate(-90.000000) translate(-8.500000, -27.500000) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 8.5,
    cy: 60.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 47.5,
    x2: 7,
    y2: 55.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-3",
    strokeLinecap: "square",
    transform: "translate(8.500000, 51.500000) rotate(-90.000000) translate(-8.500000, -51.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 44.5,
    x2: 7,
    y2: 52.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-4",
    strokeLinecap: "square",
    transform: "translate(8.500000, 48.500000) rotate(-90.000000) translate(-8.500000, -48.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 50.5,
    x2: 12.5,
    y2: 50.5,
    id: "\\u76F4\\u7EBF-2\\u5907\\u4EFD-2",
    strokeLinecap: "square",
    transform: "translate(8.500000, 50.500000) rotate(-90.000000) translate(-8.500000, -50.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1.08663079e-14,
    y1: 60.5,
    x2: 17,
    y2: 60.5,
    id: "\\u76F4\\u7EBF-4\\u5907\\u4EFD",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 140.5,
    y1: 48,
    x2: 74.5,
    y2: 48,
    id: "\\u76F4\\u7EBF-11",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.5,
    y1: 48,
    x2: 1.5,
    y2: 48,
    id: "\\u76F4\\u7EBF-11\\u5907\\u4EFD",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,43.9672578 L151.460254,48.0766431 L141,52.9331894 L141,43.9672578 Z",
    id: "\\u77E9\\u5F62"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-7",
    fill: "#FF4D4F",
    transform: "translate(62.000000, 48.000000) rotate(90.000000) translate(-62.000000, -48.000000) ",
    x: 57.5,
    y: 36,
    width: 9,
    height: 24
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowOutGoingSwitchClose);
export default __webpack_public_path__ + "static/media/low_outGoing_switch_close.21ed493a8f2f7442fe8ea0ad5825e9de.svg";
export { ForwardRef as ReactComponent };